module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/brides-ccc6c68e7b435e13861b52aa3af80c39.png";